module.exports = __webpack_public_path__ + "img/solution-electric-components-pic-02.c0c0b2f4.png";